export default {
  storageApiURL: process.env.REACT_APP_STORAGE_API_URL,
}
